import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import React from "react";
import { CircularProgress } from "@mui/material";

function TokenRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  const [token, setToken] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const idToken = params.get("id_token");
    const accessToken = params.get("access_token");
    const emailUser = params.get("email_user");

    if (idToken && accessToken && emailUser) {
      localStorage.setItem("id_token", idToken);
      localStorage.setItem("access_token", accessToken);
      localStorage.setItem("email_user", emailUser);

      const loginLexiaSign = async () => {
        const data = {
          email: emailUser,
          id_token: idToken,
          access_token: accessToken,
          app_id: 2,
        };

        try {
          const response = await fetch(
            process.env.REACT_APP_ENPOINT + "login-lexia-tools",
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            }
          );

          if (response.status === 401) {
            localStorage.clear();
            window.location.href = process.env.REACT_APP_RETURN_LEXIA_TOOLS;
            return;
          }

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const result = await response.json();
          setToken(result.access_token);
          localStorage.setItem("token", result.access_token);
        } catch (error) {
          console.error("Errore", error);
          window.location.href = process.env.REACT_APP_RETURN_LEXIA_TOOLS;
        }
      };

      loginLexiaSign();
    }
  }, [location]);

  useEffect(() => {
    if (token) {
      window.location.href = "/signing-pending";
    }
  }, [token]);

  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <CircularProgress style={{ color: "#1b2838" }} />
    </div>
  );
}

export default TokenRedirect;
